import * as React from "react";
import { Form, Input, Checkbox } from "antd";
import { CreateSectionFormConstants } from "../../../common/Constants";
import TextArea from "antd/lib/input/TextArea";

export interface State {}

export interface Props {
  translate: any;
  section?: any;
  getFieldDecorator: any;
  readOnly?: boolean;
}

export default class SectionForm extends React.Component<Props, State> {
  render() {
    const {
      translate,
      section,
      getFieldDecorator,
      readOnly = false
    } = this.props;

    return (
      <Form>
        <Form.Item label={translate("section_form.order_number")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.ORDER_NUMBER, {
            initialValue: section && section.orderNumber,
            rules: [
              {
                required: true,
                message: translate("section_form.required_message", {
                  field: translate("section_form.order_number")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.order_number_visible")}>
          {getFieldDecorator(
            CreateSectionFormConstants.Fields.ORDER_NUMBER_VISIBLE,
            {
              valuePropName: "checked",
              initialValue: section ? section.orderNumberVisible : false,
              rules: [
                {
                  required: true,
                  message: translate("section_form.required_message", {
                    field: translate("section_form.order_number_visible")
                  })
                }
              ]
            }
          )(<Checkbox disabled={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.field_required")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.REQUIRED, {
            valuePropName: "checked",
            initialValue: section ? section.required : false,
            rules: [
              {
                required: true,
                message: translate("section_form.required_message", {
                  field: translate("section_form.field_required")
                })
              }
            ]
          })(<Checkbox disabled={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.name")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.NAME, {
            initialValue: section && section.name,
            rules: [
              {
                required: true,
                message: translate("section_form.required_message", {
                  field: translate("section_form.name")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.label")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.LABEL, {
            initialValue: section && section.label,
            rules: [
              {
                required: false,
                message: translate("section_form.required_message", {
                  field: translate("section_form.label")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.label_visible")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.LABEL_VISIBLE, {
            valuePropName: "checked",
            initialValue: section ? section.labelVisible : false,
            rules: [
              {
                required: true,
                message: translate("section_form.required_message", {
                  field: translate("section_form.label_visible")
                })
              }
            ]
          })(<Checkbox disabled={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.description")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.DESCRIPTION, {
            initialValue: section && section.description,
            rules: [
              {
                required: false,
                message: translate("section_form.required_message", {
                  field: translate("section_form.description")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
              maxLength={
                CreateSectionFormConstants.VALIDATION_RULES
                  .DESCRIPTION_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
        <Form.Item label={translate("section_form.comment")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.COMMENT, {
            initialValue: section && section.comment,
            rules: [
              {
                required: false,
                message: translate("section_form.required_message", {
                  field: translate("section_form.comment")
                })
              }
            ]
          })(
            <TextArea
              readOnly={readOnly}
              autoSize={{ minRows: 3 }}
            />
          )}
        </Form.Item>
        <Form.Item label={translate("section_form.max_number")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.MAX_NUMBER, {
            initialValue: section && section.maxNumber,
            rules: [
              {
                required: true,
                message: translate("section_form.required_message", {
                  field: translate("section_form.max_number")
                })
              }
            ]
          })(<Input readOnly={readOnly} />)}
        </Form.Item>
        <Form.Item label={translate("section_form.portal_aggregate")}>
          {getFieldDecorator(CreateSectionFormConstants.Fields.PORTAL_AGGREGATE, {
            initialValue: section && section.portalAggregate,
            valuePropName: "checked",
            rules: [
              {
                required: true,
                message: translate("section_form.required_message", {
                  field: translate("section_form.portal_aggregate")
                })
              }
            ]
          })(<Checkbox disabled={readOnly} />)}
        </Form.Item>
      </Form>
    );
  }
}
